import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html'
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;
  user_data =[]; 
  user_name = '';
  user_image = '';
  user_type = '';

  constructor() {}
  ngOnInit() {
    this.user_data = JSON.parse(localStorage.getItem('currentUser'));
    this.user_name = this.user_data[0]['user_name'];
    this.user_image = "http://neport.snru.ac.th/FILES/"+this.user_data[0]['pic'];
    this.user_type = this.user_data[0]['user_type'];
  }

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        {name: 'SUBITEM', state: 'cards'},
        {name: 'SUBITEM', state: 'buttons'}
      ]
    });
  }
}


// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/shared/components/sidenav/sidenav.component.ts